export default {
  apiUrl: 'https://api.gymcloud.com',
  wsUrl: 'wss://api.gymcloud.com/cable',
  facebook: {
    app_id: '444988735644338',
    pixel_id: '116010479055307',
  },
  google: {
    client_id: '512657583504-f9e94bg98gfg0mavfqv84nqthv9o0acg.apps.googleusercontent.com',
  },
  sentry: {
    dsn: 'https://b6211215cb3d05efa0919d2d4dd8f526@o4506985244786688.ingest.us.sentry.io/4508317837230080',
  },
  mixpanel: {
    token: 'e475cb77db21ff1abb109dc18c0e9f13',
  },
  hotjar: {
    hjid: 154712,
    hjsv: 5,
  },
  google_analytics: {
    account: 'UA-74824574-3',
  },
  gtm: {
    account: 'GTM-5M6HF4',
  },
  urls: {
    landing: 'https://www.gymcloud.com',
    support: 'http://support.gymcloud.com/support/home',
    freshdesk: 'https://gymcloud.freshdesk.com/support/home',
  },
  stripe: {
    key: 'pk_live_OaMTNwWnnagp4nLqJhwrkiUU',
    client_id: 'ca_FH0Pix2m1ncPN9PLtu8IrIpLk1J7ch99',
  },
  mobile: {
    app: 'gymcloud://',
    url: 'https://mobile.gymcloud.com',
    app_store_url: 'https://itunes.apple.com/qa/app/gymcloud/id1004581098',
    google_play_url: 'https://play.google.com/store/apps/details?id=com.gymcloud.mobile',
  },
};
